var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGossip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.075,
    height: 19,
    viewBox: "0 0 19.075 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gossip",
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9006",
    "data-name": "Path 9006",
    d: "M13,1H2.2A1.2,1.2,0,0,0,1,2.2V9.4a1.2,1.2,0,0,0,1.2,1.2H4V13l2.4-2.4H13a1.2,1.2,0,0,0,1.2-1.2V2.2A1.2,1.2,0,0,0,13,1Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9007",
    "data-name": "Path 9007",
    d: "M11,16.936v.6a6,6,0,0,0,1.757,4.241L11,23.536h6a6,6,0,0,0,3-11.2",
    transform: "translate(-4 -4.536)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_24",
    "data-name": "Line 24",
    x2: 9,
    transform: "translate(3 5)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_25",
    "data-name": "Line 25",
    x2: 9,
    transform: "translate(3 7)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGossip);
export default __webpack_public_path__ + "static/media/Gossip.97bef43b733f8aef14d38256ed8923ce.svg";
export { ForwardRef as ReactComponent };